module.exports = __webpack_public_path__ + "static/img/con-1.b464766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/con-1.png
// module id = uSS2
// module chunks = 1